import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';
import './button.scss';

type ButtonProps = {
  variant?: 'default' | 'alert' | 'info' | 'dashed';
};

function Button({
  className,
  variant = 'default',
  children,
  ...props
}: ComponentProps<'button'> & ButtonProps) {
  return (
    <button className={cn('button', variant, className)} {...props}>
      {children}
    </button>
  );
}

export { Button };
